import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Table } from 'react-bootstrap'
import { useStateValue } from '../../state'
import ButterToast, { Cinnamon } from 'butter-toast'
import { client } from '@Utils'
import { RemoveConfirmModal } from '../modals/RemoveConfirmModal'
import { LoadingSpinner } from '../../../components'

export const ContextCourse = ({ match }) => {
  const [currentState, dispatch] = useStateValue()

  const [removeResLinkModalOpen, toggleRemoveModal] = useState(false)
  const [removeResLinkURL, setRemoveResLinkURL] = useState('')
  const [removeResLinkMessage, setRemoveResLinkMessage] = useState('')
  const [responseReturned, setResponseReturned] = useState(false)

  useEffect(() => {
    const getResourceLinks = async () => {
      try {
        let resp = await client.get(
          `/account/admin_lti13.getResourceLinks/-/${match.params.contextCourseId}/`
        )
        dispatch({ type: 'updateMessage', message: null })
        dispatch({
          type: 'updateResourceLinks',
          resourceLinks: resp.data.resourceLinks,
        })
        dispatch({ type: 'updateCourse', course: resp.data.course })

        if (resp.data.error) {
          dispatch({ type: 'updateMessage', message: resp.data.error })
        }
      } catch (err) {
        if (err.response) {
          if (err.response.status === 500) {
            ButterToast.raise({
              content: (
                <Cinnamon.Crisp
                  title={err.response.statusText}
                  content={err.response.data.error}
                  scheme={Cinnamon.Crisp.SCHEME_RED}
                  icon={<i className="far fa-thumbs-down fa-3x" />}
                />
              ),
            })
          } else {
            dispatch({
              type: 'updateMessage',
              message: err.response.data.error,
            })
          }
        } else {
          dispatch({ type: 'updateMessage', message: err })
          alert(err)
        }
      } finally {
        setResponseReturned(true)
      }
    }
    getResourceLinks()
  }, [currentState.reloadSwitch])

  const openModal = resLinkObject => {
    setRemoveResLinkURL(
      `/account/admin_lti13.deleteResourceLink/-/${resLinkObject.id}/`
    )
    setRemoveResLinkMessage(
      `Are you sure you want to remove Resource Link with guid: ${resLinkObject.guid}?`
    )
    toggleRemoveModal(true)
  }

  const getLinkData = resLinkObject => {
    let actLength = 0
    if (resLinkObject.embeddedActivities.length > 0) {
      actLength = resLinkObject.embeddedActivities.length
    }
    return (
      <div>
        <div>
          MyEd: <a href={resLinkObject.link}>{resLinkObject.link}</a>
          <p>LMS: {resLinkObject.lineItemUrl}</p>
          {resLinkObject.lineItemJson && (
            <div>
              <p>Line Item JSON:</p>
              <ul>
                <li>label: {resLinkObject.lineItemJson.label}</li>
                <li>id: {resLinkObject.lineItemJson.id}</li>
                <li>scoreMaximum: {resLinkObject.lineItemJson.scoreMaximum}</li>
                <li>tag: {resLinkObject.lineItemJson.tag}</li>
                <li>resourceId: {resLinkObject.lineItemJson.resourceId}</li>
                <li>
                  resourceLinkId: {resLinkObject.lineItemJson.resourceLinkId}
                </li>
              </ul>
            </div>
          )}
          {actLength > 0 ? (
            <div>
              Embedded Acts:
              <ul>
                {resLinkObject.embeddedActivities.map(embAct => (
                  <li key={`embAct-${embAct.guid}`}>
                    <a
                      href={`/instructor/activity_submissions/${resLinkObject.course.coursenum}/${embAct.id}`}
                    >
                      {embAct.title}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ) : null}
        </div>
      </div>
    )
  }

  const getLinkFoundStatus = resLinkObject => {
    // Found in LineItems API response
    if (resLinkObject.inLineItems) {
      if (
        resLinkObject.link_type == 'book_node' ||
        resLinkObject.link_type == 'title'
      ) {
        return <span className="label label-warning">Misconfigured</span>
      }
      return <span className="label label-success">Yes</span>
    }

    // Not found in LineItems but has been launched to before
    // In this case, the Line Item was probably deleted from the LMS. This is a problem!
    if (
      resLinkObject.link_type == 'activity' &&
      resLinkObject.launchCount > 0
    ) {
      return <span className="label label-warning">Deleted</span>
    }

    // Book  or Title link and we have seen a launch
    if (
      (resLinkObject.link_type == 'book_node' ||
        resLinkObject.link_type == 'title') &&
      resLinkObject.launchCount > 0
    ) {
      return <span className="label label-success">Yes</span>
    }

    // Book link that has no launches so we don't know
    return <span className="label label-danger">No</span>
  }

  const linkTypes = {
    activity: 'Activity',
    book_node: 'Book Link',
    title: 'Title Link',
  }

  return (
    <React.Fragment>
      <div className="mb-2">
        <Link
          className="btn btn-default btn-myed btn-default-myed btn-sm-myed mr-4"
          to={`/account/admin_lti13/-/platforms/${match.params.lmsCode}/issuers/${match.params.issuerId}/clients/${match.params.clientId}/deployments/${match.params.deploymentId}/contexts/${match.params.contextId}`}
        >
          <div className="far fa-arrow-circle-left fa-fw mr-2" /> Go Back
        </Link>
      </div>
      <div className="card-myed">
        <h3>Resource Links</h3>
        {currentState.course && (
          <div>
            <p>
              <span style={{ fontSize: '1.2em', fontWeight: 'bolder' }}>
                Course Number:
              </span>{' '}
              {currentState.course.courseNum}
            </p>
            <p>
              <span style={{ fontSize: '1.2em', fontWeight: 'bolder' }}>
                Course Title:
              </span>{' '}
              {currentState.course.courseTitle}
            </p>
          </div>
        )}
        {responseReturned ? (
          <Table striped bordered condensed hover>
            <thead>
              <tr>
                <th>ID</th>
                <th>GUID</th>
                <th>Resource Title</th>
                <th>LMS Label</th>
                <th>Type</th>
                <th>Launch Count</th>
                <th>Link Info</th>
                <th>Found in LMS</th>
                <th>Action</th>
                <th>Remove?</th>
              </tr>
            </thead>
            <tbody>
              {currentState.resourceLinks.map((reslink, i) => (
                <tr key={i}>
                  <td>{reslink.id}</td>
                  <td>{reslink.guid}</td>
                  <td>{reslink.title}</td>
                  <td>{reslink.lineItemJson && reslink.lineItemJson.label}</td>
                  <td>{linkTypes[reslink.link_type]}</td>
                  <td>{reslink.launchCount}</td>
                  <td>{getLinkData(reslink)}</td>
                  <td>{getLinkFoundStatus(reslink)}</td>
                  <td>
                    {reslink.link_type === 'activity' && (
                      <Link
                        to={`/account/admin_lti13/-/platforms/${match.params.lmsCode}/issuers/${match.params.issuerId}/clients/${match.params.clientId}/deployments/${match.params.deploymentId}/contexts/${match.params.contextId}/contextCourses/${match.params.contextCourseId}/resourceLinks/${reslink.id}`}
                      >
                        View Results
                      </Link>
                    )}
                  </td>
                  <td>
                    {((!reslink.inLineItems &&
                      reslink.link_type === 'activity') ||
                      (reslink.launchCount < 1 &&
                        reslink.link_type !== 'activity')) && (
                      <a
                        onClick={() => openModal(reslink)}
                        className="btn btn-sm btn-sm-myed btn-danger"
                      >
                        Remove <i className="far fa-window-close" />
                      </a>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          <div>
            <div className="d-flex justify-content-center">
              <p>Pulling Resource Link info from LMS...</p>
            </div>
            <div className="d-flex justify-content-center">
              <LoadingSpinner
                style={{ fontSize: '10em', color: '#004876' }}
                outerClass={'block'}
              />
            </div>
          </div>
        )}
      </div>
      <RemoveConfirmModal
        modalTitle="Remove Resource Link"
        message={removeResLinkMessage}
        endpoint={removeResLinkURL}
        show={removeResLinkModalOpen}
        toggle={toggleRemoveModal}
        currentState={currentState}
        dispatch={dispatch}
      />
    </React.Fragment>
  )
}
